import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

/**
 * Catch-all 404 page. Sets noindex so unmatched client-side routes are not indexed (avoids soft-404).
 */
const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Al Sayyed</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-center text-white px-4">
          <h1 className="text-4xl font-bold mb-2">404</h1>
          <p className="text-xl text-gray-300 mb-6">Page not found</p>
          <Link
            to="/"
            className="inline-block bg-red-600 hover:bg-red-700 px-6 py-2 rounded-lg transition-colors"
          >
            Back to Home
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
